import PlaybarGif from "@src/app/assets/lottie/playbar.gif";
import cx from "classnames";
import type { ReactElement } from "react";

interface Props {
  className?: string;
}

export default function VideoPlayingIcon({
  className = "",
}: Props): ReactElement {
  return (
    <div data-testid="video-playing-icon" className={cx(className)}>
      <img
        src={PlaybarGif}
        alt="Video Playing"
        className="size-full scale-[1.15]"
      />
    </div>
  );
}
